// extracted by mini-css-extract-plugin
export default {"root":"_13iBT","content":"gAgpn"};